import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ResetPasswordService {
	private url = environment.api;

	constructor(private http: HttpClient) { }

	sendResetRequest(data: any) {
		return this.http.post(this.url + "api/user/password/change", data);
	}
}